import { UIClassesSpec } from '../types';
import { UIView, UIViewSpec, UIViewTag } from '../view';
import { UIAdapter } from './adapter';
import { UIBasicLayout, UIListLayout, UIScrollLayout } from './layout';

export interface UIListOptions<T extends UIViewSpec> {
    tag?: UIViewTag;
    classes?: UIClassesSpec;
    progressive?: boolean;
    layout?: UIListLayout<T>;
}

export class UIList<T extends UIViewSpec = UIViewSpec> extends UIView {
    // private _sections!: UIAdapter<T>[];
    private _layout: UIListLayout<T>;
    private _highlighted?: UIView;

    constructor(sections: UIAdapter<T> | UIAdapter<T>[] = [], options: UIListOptions<T> = {}) {
        super(options.tag, options.classes);

        this._layout = options.layout || (options.progressive ? new UIScrollLayout : new UIBasicLayout);
        this._layout.attach(this);
        this.sections = Array.isArray(sections) ? sections : [sections];
    }

    set sections(sections: UIAdapter<T>[]) {
        // this._sections = sections;
        this._layout.init(sections);
    }

    onOrder(view: UIViewSpec) {
        return this._layout.onOrder(view);
    }

    highlight(view: UIView) {
        if(this._highlighted)
            this._highlighted.classList.remove('f-highlighted');
        view.classList.add('f-highlighted');
        this._highlighted = view;
    }
}
